import DragDropUpload from "../../../../../components/dragDropUpload/dragDropUpload";

interface PayerPdfUploadProps {
  filePath?: string;
  onUploadedUrlChange: (url: string) => void;
  onFileSelectionChange: (hasSelectedFile: boolean) => void;
}

/** Optional PDF upload whose pending state gates form submission. */
const PayerPdfUpload = ({
  filePath,
  onUploadedUrlChange,
  onFileSelectionChange,
}: PayerPdfUploadProps) => (
  <div className="border-b border-t border-primaryGray-15 py-3">
    <div className="mb-2 flex justify-between text-tiny font-medium text-primaryGray-1">
      Payer PDF
      <div className="text-right text-primaryGray-9">optional</div>
    </div>
    <DragDropUpload
      id="historic-nar-payer-pdf"
      filePath={filePath}
      subText="Drag and drop or click to upload a PDF (up to 10 MB)"
      allowedFileTypes={[".pdf"]}
      maxFileSize={10 * 1024 * 1024}
      downloadedURL={(urls) => onUploadedUrlChange(urls[0] ?? "")}
      fileDetails={(files) => onFileSelectionChange(files.length > 0)}
      useAlternateUploadUI
    />
  </div>
);

export default PayerPdfUpload;
